import ResumenPago from 'components/Resumen/ResumenPago'
import React from 'react'
import { PRODUCTOS } from 'utils/constants'
import { LF } from './Constantes/general'

export const LFResumen = (props) => {

    return (
        <ResumenPago 
        productoCodigoCore={PRODUCTOS.LINEAS_FINANCIERAS} 
        urlGoTo={LF.urls.facturacion} 
        urlBackTo={LF.urls.planes}
               {...{ ...props }}></ResumenPago>
    )
}
